var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccTechnology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8395",
    "data-name": "Rectangle 8395",
    width: 28,
    height: 28,
    transform: "translate(436 2246)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8394",
    "data-name": "Rectangle 8394",
    width: 25.036,
    height: 18.752,
    transform: "translate(1.481 4.625)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tech_shops",
    "data-name": "Tech shops",
    transform: "translate(-436 -2246)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35253",
    "data-name": "Group 35253",
    transform: "translate(436.001 2245.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35252",
    "data-name": "Group 35252",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35895",
    "data-name": "Path 35895",
    d: "M22.584,4.624H5.415A1.989,1.989,0,0,0,3.434,6.605V17.831H6.076V7.266H21.924V17.831h2.642V6.605a1.988,1.988,0,0,0-1.982-1.981M14,6.71a.752.752,0,1,1,.752-.752A.752.752,0,0,1,14,6.71",
    fill: "#b3b5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35896",
    "data-name": "Path 35896",
    d: "M25.892,19.553h-7.2v.13a1.07,1.07,0,0,1-1.07,1.069H10.381a1.07,1.07,0,0,1-1.07-1.068h0v-.13h-7.2a.635.635,0,0,0-.626.637v.638a2.531,2.531,0,0,0,2.5,2.545h20.03a2.531,2.531,0,0,0,2.5-2.549v-.638a.659.659,0,0,0-.626-.637",
    fill: "#b3b5c4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccTechnology);
export default __webpack_public_path__ + "static/media/mcc_technology.70d3ff41ba268b3980f17489163facff.svg";
export { ForwardRef as ReactComponent };